import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getAudiences } from "../../../store/action/audiencesAction";

const Filter = ({
  currentPage,
  pageConstant,
  onSearchNameChange,
  searchName,
 
}) => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState(searchName);

  const handleSearch = (event) => {
    setSearchValue(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSearchNameChange(searchValue);
      dispatch(getAudiences(undefined, undefined, searchValue));
    }
  };

  return (
    <div className="customer-filter-container-master">
      <div className="hrs-filter-container-master">
        <div className="hrs-filter-container">
          <div className="hrs-filter-wrapper">
            <div className="hrs-btn-open-filter">
              <div
                className="svg-next-icon"
                style={{
                  backgroundImage:
                    'url("https://static.harasocial.com/svg-funnel/filter.svg")',
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center center",
                  backgroundSize: "14px",
                  width: "14px",
                  height: "14px",
                }}
              ></div>
              <span>Bộ lọc tìm kiếm</span>
            </div>
          </div>
          <div className="hrs-filter-search-wrapper">
            <svg width="16" height="16" viewBox="0 0 16 16">
              <path
                fill="#8993A4"
                fillRule="evenodd"
                d="M6.8 13.6a6.8 6.8 0 115.34-2.59l3.626 3.624a.8.8 0 01-1.132 1.132L11.01 12.14A6.77 6.77 0 016.8 13.6zm3.728-3.175a.817.817 0 00-.103.103 5.2 5.2 0 11.102-.102z"
                clipRule="evenodd"
              ></path>
            </svg>
            <input
              className="hrs-filter-input-search"
              type="text"
              placeholder={
                currentPage === pageConstant.CUSTOMER
                  ? "Nhập tên khách hàng"
                  : "Nhập tên nhóm khách hàng"
              }
              value={searchValue}
              onChange={handleSearch}
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className="hrs-condition-container mt10"></div>
        </div>
      </div>
    </div>
  );
};

export default Filter;